import React from 'react'
import { FiRss, FiTwitter } from 'react-icons/fi'

import { withMicrocopy } from '~contexts/MicrocopyContext'
import Link from '~components/Link'
import InternationalSites from './InternationalSites'

import ThreeColumnLayout from '~layouts/ThreeColumnLayout'

import style from './Footer.module.scss'

import List from './List'

const Footer = ({
  microcopy,
  color,
  alignment = 'wide'
}) => (
  <footer 
    className={style.footer} 
    data-color={color}
  >
    <section>
      <ThreeColumnLayout alignment={alignment} padding={false}>
        <></>
        <SocialLinks microcopy={microcopy} />
      </ThreeColumnLayout>
    </section>
    <section>
      <ThreeColumnLayout alignment={alignment} padding={false}>
        <></>
        <Lists microcopy={microcopy} />
      </ThreeColumnLayout>
    </section>
    <section>
      <ThreeColumnLayout alignment={alignment} padding={false}>
        <></>
        <List id='footer.bottom' microcopy={microcopy} showCopyright />
      </ThreeColumnLayout>
    </section>
  </footer>
)

const SocialLinks = ({
  microcopy
}) => (
  <>
    <Link 
      microcopy={microcopy}
      aria-label={microcopy.text('footer.categories.company.links.devblog.text')}
      to={microcopy.text('footer.categories.company.links.devblog.url')}
    >
      <FiRss />
    </Link>
    <Link 
      microcopy={microcopy}
      aria-label={microcopy.text('footer.categories.company.links.twitter.text')}
      to={microcopy.text('footer.categories.company.links.twitter.url')}
    >
      <FiTwitter />
    </Link>
  </>
)

const Lists = ({
  microcopy
}) => (
  <>
    <List id='footer.categories.company' microcopy={microcopy} showTitle />
    <List id='footer.categories.tooling' microcopy={microcopy} showTitle />
    <List id='footer.categories.code' microcopy={microcopy} showTitle />
    <List id='footer.categories.support' microcopy={microcopy} showTitle />
    <InternationalSites microcopy={microcopy} />
  </>
)

export default withMicrocopy(Footer)